import { Component, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
@Component({
  selector: 'app-custom-special-condition',
  templateUrl: './custom-special-condition.component.html',
  styleUrls: ['../parts.css']
})
export class CustomSpecialConditionComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  firstCondition: Array<any> = []; // 条件一拉下条件
  firstConditionValue = '特定条件满足'; // 条件一默认文字
  secondConditionValue = '分组'; // 条件二默认文字
  firstConditionId = null; // 存放条件一选中ID
  secondConditionId = null; // 存放条件二选中ID
  isVisible = false; // 弹窗显示控制
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId = null;
  schedulerConditionDisplayText = '定时'; // 定时默认文字
  schedulerConditionData: any; // 存放定时数据
  schedulerConditionVisible: boolean; // 定时pop是否关闭
  firstConditionVisible: boolean; // pop是否关闭
  secondConditionVisible: boolean; // pop是否关闭
  taskIntegrationData: any = {}; // 存放任务数据
  instanceData: any = {}; // 存放实例返填数据
  backFillData: any; // 回填数据
  categorieId: string; // 存放当前目录ID
  automation: any = {
    'boardId': '',
    'groupId': '',
    'categoryId': '',
    relationId: '',
    'schedulerConfig': {},
    'schedulerDescription': '',
    'conditions': [],
    'taskMapping': {},
    'instanceDescription': ''
  }; // 存放入参数据
  @ViewChild('pulseIntegration') pulseIntegration: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    this.firstCondition = [
      {
        'id': 'feeAuto',
        'title': '费用支付'
      }
    ];
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 处理返填数据
    if (JSON.stringify(this.instanceData) !== '{}') {
      this.backFillData = this.instanceData.config.taskMapping;
      // 反填定时
      this.schedulerConditionData = this.instanceData.config.schedulerConfig;
      this.schedulerConditionDisplayText =
        this.instanceData.config.schedulerDescription ? this.instanceData.config.schedulerDescription : '定时';
      // 反填条件
      this.firstCondition.forEach((item, index) => {
        if (item.id === this.instanceData.config.conditions[0].value) {
          this.firstConditionValue = item.title;
        }
      });
      this.firstConditionId = this.instanceData.config.conditions[0].value;
      // 反填分组
      this.boardGroupData.forEach((item, index) => {
        if (item.id === this.instanceData.config.groupId) {
          this.secondConditionValue = item.title;
        }
      });
      this.secondConditionId = this.instanceData.config.groupId;
      // 触发发射事件
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.packageData(this.automation);
    }
  }
  // 条件一变更
  firstConditionChange(item) {
    this.firstConditionValue = item.title;
    this.firstConditionId = item.id;
    this.automation.conditions = [];
    const obj = {
      'field': 'feeType',
      'operator': 'is',
      'value': item.id
    };
    this.firstConditionVisible = false;
    this.automation.conditions.push(obj);
    this.packageData(this.automation);
  }
  // 条件二变更
  secondConditionChange(item) {
    this.secondConditionVisible = false;
    this.secondConditionValue = item.title;
    this.secondConditionId = item.id;
    this.automation.groupId = this.secondConditionId;
    this.packageData(this.automation);
  }
  // 弹窗创建任务
  openTaskDialog() {
    this.isVisible = true;
  }
  // 弹窗确定事件
  handleOk() {
    this.pulseIntegration.onSubmit();
    this.isVisible = false;
  }
  // 弹窗关闭事件
  handleCancel() {
    this.isVisible = false;
  }
  // 获取定时数据
  getSchedulerData(event) {
    this.schedulerConditionVisible = false;
    this.schedulerConditionDisplayText = event.text;
    this.schedulerConditionData = event.config;
    this.automation.schedulerDescription = this.schedulerConditionDisplayText;
    this.automation.schedulerConfig = this.schedulerConditionData;
    this.packageData(this.automation);
  }
  // 获取任务创建数据
  getTaskIntegrationData(event) {
    this.taskIntegrationData = event;
    const obj: any = {};
    event.forEach((item, index) => {
      let mapObj: any;
      if (typeof item.mappingValue === 'string') {
        switch (item.type) {
          case 'dropdown':
            mapObj = {
              'fixedValue': {
                'ids': [item.mappingValue]
              }
            };
          break;
          case 'select':
            mapObj = {
              'fixedValue': {
                'option': item.mappingValue
              }
            };
            break;
          case 'button':
            mapObj = {
              'fixedValue': {
                'original': item.mappingValue
              }
            };
            break;
        }
      }
      if (item.type === 'dropdown' || item.type === 'select' || item.type === 'button') {
        obj[item.id] = mapObj;
      } else {
        const mpArr = [];
        item.mappingValue.forEach((m, i) => {
          mapObj = {
            'type': 'field',
            'sourceField': {
              'id': m.id,
              'type': m.type ? m.type : 'text',
              'title': m.title
            }
          };
          mpArr.push(mapObj);
        });
        mpArr.unshift({'type': 'text', 'text': item.mappingFirstValue});
        mpArr.push({'type': 'text', 'text': item.mappingEndValue});
        obj[item.id] = {
          'targetField': {
            'id': item.id,
            'title': item.title,
            'type': item.type,
          },
          'mappingParts': mpArr
        };
      }
      this.automation.taskMapping.mappingConfig = obj;
    });
    this.packageData(this.automation);
  }
  // 组件提交数据
  packageData(data) {
    const txt = this.schedulerConditionDisplayText ? `${this.schedulerConditionDisplayText.slice(0, 24)}...` : this.schedulerConditionDisplayText;
    const instanceDescription = txt + '，当' + this.firstConditionValue + '时，在'  + this.secondConditionValue + '中，创建任务';
    data.instanceDescription = instanceDescription;
    this.nfDataChange.emit(data);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return JSON.stringify(this.automation.schedulerConfig) !== '{}' &&
      this.firstConditionId &&
      this.secondConditionId &&
      JSON.stringify(this.automation.taskMapping) !== '{}';
  }
}
